<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text class="router-link-exact-active font-weight-bold" v-bind="attrs" v-on="on">
        ResearchHUB Guidelines
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-1.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-2.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-3.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-4.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-5.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-6.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-7.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-8.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-9.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-10.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-11.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-12.png')"
          width="100%"
        />
        <img
          :src="require('@/assets/howitworks/ResearchHUB Guiding Principles 11 06 2024-13.png')"
          width="100%"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GuidelinesModal',
  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped>
.router-link-exact-active {
  color: var(--v-primary300-base) !important;
}
</style>
